/** `PartialResultNote` の文言(空状態でも同じ一文を使うので部品の外に置く)。 */

/** 空状態・注記の一文。 */
export function partialResultText(limit: number): string {
  return `取得した先頭 ${limit} 件の中から絞り込んでいます。取得範囲外のものは含まれません`;
}

/** 戻る操作の文言(表の上の注記と空状態で同じ)。 */
export const PARTIAL_CLEAR_LABEL = "条件を外して全件を見る";
